import React, {
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./style.scss";
import { Link, useLocation } from "react-router-dom";
import ResponsiveLogo from "../../common/ResponsiveLogo";
import { ReactComponent as ArrowDown } from "../../../static/icones/arrow-down.svg";
import AuthContext from "../../../contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { ReactComponent as NavbarHome } from "../../../assets/icons/navbar-home.svg";
import InstallerManagement from "../../../assets/icons/InstallerManagement";
import { ReactComponent as ConfigurationsIcon } from "../../../assets/icons/configurations.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { Home } from "../../../lib/Home";
import { Device } from "../../../lib/Device";

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const [openUserPortal, setOpenUserPortal] = useState(false);
  const first_click = useRef(false);
  const { t } = useTranslation("main");
  const homes = useSelector<RootState, Home[] | null>(
    (state) => state.homes as Home[] | null
  );
  const devices = useSelector<RootState, Device[] | null>(
    (state) => state.devices as Device[] | null
  );
  const isBasicUser = !user.is_installer && !user.is_advanced_user;

  const settingsLink = useMemo(() => {
    if (!homes || homes.length === 0) {
      return null;
    }
    const firstHome = homes[0];
    const homeDevices =
      devices?.filter((device) => device.home === firstHome.id) ?? [];
    if (homeDevices.length > 0) {
      return `/home/${firstHome.id}/${homeDevices[0].id}/settings`;
    }
    return `/home/${firstHome.id}/settings`;
  }, [homes, devices]);

  const handle_click = (e: MouseEvent) => {
    if (first_click.current) {
      setOpenUserPortal(false);
    }
    first_click.current = true;
  };

  useEffect(() => {
    if (openUserPortal) {
      document.addEventListener("click", handle_click);

      return () => {
        document.removeEventListener("click", handle_click);
        first_click.current = false;
      };
    }
  }, [openUserPortal]);

  return (
    <nav className="main-navbar">
      <Link aria-label="Soliseco home" className="home-logo" to={"/"}>
        <ResponsiveLogo alt="soliseco logo" />
      </Link>
      <ul className="center-navigation">
        <li className={location.pathname === "/" ? "selected" : ""}>
          <Link to={"/"}>
            <NavbarHome />
            <span>{t("home")}</span>
          </Link>
        </li>
        {user.is_installer && (
          <>
            <li className={location.pathname.startsWith("/installer/management") ? "selected" : ""}>
              <Link to={"/installer/management"}>
                <InstallerManagement />
                <span>{t("users_management")}</span>
              </Link>
            </li>
            <li className={location.pathname.startsWith("/installer/configurations") ? "selected" : ""}>
              <Link to={"/installer/configurations"}>
                <ConfigurationsIcon />
                <span>{t("configurations")}</span>
              </Link>
            </li>
            <li className={location.pathname.startsWith("/installer/partners") ? "selected" : ""}>
              <Link to={"/installer/partners"}>
                <InstallerManagement />
                <span>{t("installer_partners")}</span>
              </Link>
            </li>
          </>
        )}
      </ul>
      <div className="right-actions">
        {isBasicUser && settingsLink && (
          <Link className="quick-settings-btn" to={settingsLink}>
            <ConfigurationsIcon />
            <span>{t("home_device_settings")}</span>
          </Link>
        )}
        <div className="user-portal-btn" onClick={() => setOpenUserPortal(true)}>
          <img
            alt="user initials icon"
            src={`https://api.dicebear.com/7.x/initials/png?seed=${user.first_name}+${user.last_name}`}
          />
          {/* <span className="user-name">
          {user.first_name} {user.last_name}
        </span> */}
          <ArrowDown />
          {openUserPortal && (
            <div className="user-portal">
              <Link to={"/account"}>{t("account")}</Link>
              <span onClick={logout}>{t("logout")}</span>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
